import React, { Component } from 'react';
import { HashRouter, Route, Switch, Redirect} from 'react-router-dom';
import MyPage from './views/Pages/MyPage/MyPage.jsx';
// import MyPages from './views/Pages/MyPage/ThankYou.jsx';
import { isAuthenticated } from './auth/authenticate';
// import { renderRoutes } from 'react-router-config';
import './App.scss';
import Login from './views/Pages/Login'
import Registration from './views/Pages/Registration/Registration.jsx';
import Processing from './views/Pages/MyPage/Processing';
import { toast } from "react-toastify";
import Nanny from './views/Pages/NannyApplicationForm/Nanny.js';
import 'bootstrap/dist/css/bootstrap.min.css';
toast.configure();

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));

// Pages
// const Login = React.lazy(() => import('./views/Pages/Login'));
// const Register = React.lazy(() => import('./views/Pages/Register'));
// const Page404 = React.lazy(() => import('./views/Pages/Page404'));
// const Page500 = React.lazy(() => import('./views/Pages/Page500'));


const UnauthenticatedRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    (isAuthenticated() === false)
      ? <Component {...props} />
      : <Redirect to='/' />
  )} />
);


const AuthenticatedRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    (isAuthenticated() === true)
      ? <Component {...props} />
      : <Redirect to='/' />
  )} />
);

class App extends Component {

  render() {
    return (
      <HashRouter>
        <React.Suspense fallback={loading()}>
          <Switch>
            <Route exact path="/" name="Login Page" component={Login} />
            <Route exact path="/nanny-application-form" name="Nanny Page" component={Nanny} />
            <AuthenticatedRoute exact path="/registration" name="Registration" component={Registration} />
            <AuthenticatedRoute exact path="/processing" name="Processing" component={Processing} />
            {/* <AuthenticatedRoute exact path="/thank-you" name="My Pages" component={MyPages} /> */}
            <AuthenticatedRoute exact path="/" name="Home" component={DefaultLayout} />
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
